<template>
  <div class="page">
    <v-container>
      <v-form ref="form">
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="3">
            <v-text-field
              label="Formação"
              v-model="form.filters.formacao"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <sigfoco-date-picker
            :cols="3"
            label="Data de Realização"
            v-model="form.filters.dataRealizacao"
            removeIcon
            outlined
            dense
          ></sigfoco-date-picker>
          <v-col cols="3">
            <v-select
              label="Status"
              :items="statusSolicitacao"
              :item-text="'descricao'"
              :item-value="'descricao'"
              v-model="form.filters.status"
              outlined
              dense
            ></v-select>
					</v-col>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sigfoco-tooltip
              :text="'Buscar'"
              :icon="'mdi-magnify'"
              @click="buscarAtas()"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              :text="'Limpar'"
              :icon="'mdi-eraser'"
              @click="resetForm()"
            ></sigfoco-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5"
        :headers="headers"
        :items="form.lists.listAtas"
        :items-per-page="10"
        :footer-props="$footerProps"
      >
        <template v-slot:[`item.formacao`]="{ item }">
          {{ item.formacao }}
        </template>
        <template v-slot:[`item.dataRealizacao`]="{ item }">
          {{ $formatarData(item.dataRealizacao) }}
        </template>
        <template v-slot:[`item.ativo`]="{ item }">
          {{ item.status }}
        </template>
        <template v-slot:[`item.acoes`]="{ item }">
          <sigfoco-tooltip
            :text="isStatusConcluida(item) ? 'Baixar Ata' : 'Enviar Ata'"
            :icon="isStatusConcluida(item) ? 'mdi-arrow-down' : 'mdi-arrow-up'"
            :small="true"
            @click="isStatusConcluida(item) ? baixarAta(item) : openDialogEnviarAta(item)"
          ></sigfoco-tooltip>
        </template>
      </v-data-table>
    </v-container>
    <EnviarAtaDialog
      :visible="dialogEnviarAta.visible"
      :content="dialogEnviarAta.content"
      :edit="dialogEnviarAta.edit"
      @onClose="dialogEnviarAta.close()"
      @onSave="buscarAtas()"
    ></EnviarAtaDialog>
  </div>
</template>
  
<script>
import { Ata } from "~/commons/classes/ata";
import { Dialog } from "~/commons/classes/dialog";
import ManterAtaService from "~/services/manter-ata.service";
import EnviarAtaDialog from "./dialogs/EnviarAtaDialog.vue";
import StatusSolicitacaoEnum from "~/commons/enums/status-solicitacao.enum";

export default {
  name: "ManterAtasView",
  mixins: [ManterAtaService],
  components: {
    EnviarAtaDialog,
  },
  computed: {
    statusSolicitacao() {
      return StatusSolicitacaoEnum.values();
    },
  },
  data: () => ({
    dialogEnviarAta: Dialog.Build(),
    form: {
      filters: {
        formacao: null,
        dataRealizacao: null,
        status: null,
      },
      lists: {
        listAtas: [],
      },
    },
    headers: [
      { text: "Formação", align: "center", value: "formacao" },
      { text: "Data de Realização", align: "center", value: "dataRealizacao" },
      { text: "Status", align: "center", value: "status" },
      { text: "Ações", align: "center", value: "acoes", sortable: false },
    ],
  }),
  methods: {
    openDialogEnviarAta(ata) {
      this.dialogEnviarAta.open(new Ata(ata), true);
    },
    async baixarAta(ata) {
      const { data } = await this.$baixarAta(ata.id, { responseType: "blob" });
      const url = URL.createObjectURL(data);
      const a = document.createElement("a");
      a.href = url;
      a.download = "atas.zip";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
    buscarAtas() {
      const params = {
        formacao: this.form.filters.formacao,
        dataRealizacao: this.form.filters.dataRealizacao,
        situacao: this.form.filters.status,
      }
      this.$buscarAtas({ params }).then(
        ({ data }) => (this.form.lists.listAtas = data.lista)
      );
    },
    isStatusConcluida(ata) {
      return [
       StatusSolicitacaoEnum.CONCLUIDA,
       StatusSolicitacaoEnum.AGUARDANDO_APROVACAO_ATA,
       StatusSolicitacaoEnum.ATA_REPROVADA,
      ].includes(ata.status);
    },
    resetForm() {
        this.form.filters = {
          formacao: null,
          dataRealizacao: null,
          status: null,
        };
        this.form.lists.listAtas = [];
        this.$nextTick(() => {
            this.$refs.form.reset();
        });
      },
  },
};
</script>